import { FeedItemContentsDropdown } from "./FeedItemContentsDropdown";

export default FeedItemContentsDropdown;
